export const notifyParentOfNewHeight = (isReset) => {
  if (window.parent !== window.self) {
    // Note that if this function is called as onLoad handler, the isReset arg will be a SyntheticEvent.
    let height = (isReset === true) ? 640 : window.document.body.scrollHeight;
    window.parent.postMessage(
        JSON.stringify({name: 'arContentHeightChanged', height}),
        '*',
    );
  }
};